import { IActivityAction } from '@models/actions/IBaseAction';
import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { ICompleteProps } from './ICompleteProps';
import { CompleteModal } from './CompleteModal';

export const CompleteExecutor = createActivityModalExecutor<ICompleteProps>({
    modal: CompleteModal,
    defaultModalSize: 'm',
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        displayName: action.displayName,
        actionKey: action.key ?? '',
        actId: getActivityIdFromCompositeId(objId),
        docId: (action as IActivityAction).docId,
        commentIsRequired: action.options?.commentIsRequired ?? false,
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
